import { Component, ElementRef, HostBinding, HostListener, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'atlas-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss', '../common.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ItemComponent {
  isInteractable: boolean;
  @Input() icon: string;
  @Input() set interactable(val: string) {
    this.isInteractable = val !== 'false';
  }
  @Input() badgeContent: string | number | null;
  @Input() iconText: string;
  @Input() customClass = '';
  @Input() ariaLabel: string;

  constructor(private el: ElementRef<HTMLElement>) {}

  @HostBinding('attr.role') get hostRole() {
    return this.isInteractable ? 'button' : null;
  }

  @HostBinding('attr.tabindex') get hostTabindex() {
    return this.isInteractable ? 0 : null;
  }

  @HostBinding('attr.aria-label') get hostAriaLabel() {
    return this.ariaLabel || null;
  }

  @HostListener('keydown.enter') onEnter() {
    if (this.isInteractable) {
      this.el.nativeElement.click();
    }
  }

  @HostListener('keydown.space', ['$event']) onSpace(event: Event) {
    if (this.isInteractable) {
      event.preventDefault();
      this.el.nativeElement.click();
    }
  }
}
